import { Type } from 'class-transformer';
import { Max, Min, ValidateNested } from 'class-validator';
import {
  AddressWithOptionalCoordinates,
  BaseFilterMany,
  BaseFilterOne,
  BaseQueryMany,
  Contact,
  DateTimeRange,
  OpeningHours,
  TimeWindow,
} from '@cnx-saas/common';
import { CnxIdType } from '@cnx-saas/utils-cnx-id';
import { AllocationWidgetType, ShipmentStatus } from './ShipmentStatus';
import { ShipmentStop, ShipmentStopLocation } from './ShipmentStop';
import { ShipmentStopCompletion } from './ShipmentStopCompletion';
import { ShipmentStopEstimatedTimes } from './ShipmentStopEstimatedTimes';
import { ShipmentStopPlannedTimes } from './ShipmentStopPlannedTimes';
import { ShipmentVehicle, VehicleCapability } from './ShipmentVehicle';

export class FilterShipment extends BaseFilterOne(CnxIdType.Shipment) {}

export class FilterShipments extends BaseFilterMany(CnxIdType.Shipment) {}

export class FilterShipmentStop extends FilterShipment {
  stopId: string;
}

export class FilterShipmentOptionalStop extends FilterShipment {
  stopId?: string;
}

export class ShipmentFilters {
  status?: ShipmentStatus[];
  startDate?: DateTimeRange;
  shipmentReferenceId?: string;
  carrierNames?: string[];
  allocationWidgetType?: AllocationWidgetType;
}

export class QueryShipments extends BaseQueryMany<ShipmentFilters>() {}

export class ShipmentStopLoadPayload {
  referenceId?: string;

  customerReference?: string;

  article?: string;

  content?: string;

  @Min(0)
  @Max(52)
  pallets: number;

  @Min(0)
  @Max(37000)
  weight: number;

  @Min(0)
  ldmm: number;
}

export class ShipmentStopLocationPayload
  implements Omit<ShipmentStopLocation, 'address'>
{
  address: AddressWithOptionalCoordinates;
  company: string;
  contact?: Contact;
  loadingRequirements: VehicleCapability[];
  serviceTime: number;
  openingHours: OpeningHours;
}

export class ShipmentStopPayload
  implements
    Omit<ShipmentStop, 'id' | 'location' | 'pickUp' | 'dropOff' | 'status'>
{
  location: ShipmentStopLocationPayload;
  timeWindow: TimeWindow;

  @ValidateNested({ each: true })
  @Type(() => ShipmentStopLoadPayload)
  pickUp: ShipmentStopLoadPayload[];

  @ValidateNested({ each: true })
  @Type(() => ShipmentStopLoadPayload)
  dropOff: ShipmentStopLoadPayload[];

  estimatedTimes?: ShipmentStopEstimatedTimes;
  completion?: ShipmentStopCompletion;
  actualArrivalTime?: Date;
  plannedTimes?: ShipmentStopPlannedTimes;
}

export class ShipmentPayload {
  @ValidateNested({ each: true })
  @Type(() => ShipmentStopPayload)
  stops: ShipmentStopPayload[];

  distance?: number;

  vehicle?: ShipmentVehicle;
}

export class ShipmentStatusCountFilter {
  status: AllocationWidgetType;
}
